import * as connect from '@debbie/cortex/dist/connect/index.js';
import { h } from '@debbie/cortex/dist/index.js';
import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { load } from '../connect/utils.js';
import Errors from '../Errors.js';
const ConnectPreview = (props) => {
    const preview = connect.useConnectConnection(props.id);
    const lang = useSelector((s) => s.lang);
    return (React.createElement("div", null,
        h.isError(preview) ? React.createElement(Errors, { errors: [preview.error.message] }) : null,
        load({ preview }, ({ preview }) => {
            return (React.createElement(Link, { to: `/settings/connect/connections/${props.id}` }, lang.connect.goToConnection));
        }, 'loading')));
};
export default ConnectPreview;
//# sourceMappingURL=ConnectPreview.js.map